import moment from "moment";
import Vue from 'vue';
import ReportsService from '@/services/ReportsService';
import { router } from '@/router';
import _ from "lodash";
import store from '@/store';

function initialState() {
    return {
        PDFFileName: ''
    }
};

const state = initialState();

const mutations = {
    SET_INVOICE_FILE_NAME: (state, payload) => {
        state.PDFFileName = payload;
    }
};

const actions = {
    FETCH_INVOICE_DETAILS({ dispatch, commit, state }, payload) {

        ReportsService.GetInvoiceList(payload).then(response => {
            const { data } = response;

            if (data.status) {
                commit('SET_INVOICE_FILE_NAME', data.Record);
            }
        })
    }
};

const getters = {
    getInvoiceFileName: state => state.PDFFileName
};

export default {
    state,
    mutations,
    actions,
    getters
}


// WEBPACK FOOTER //
// ./src/store/modules/invoice.js